// extracted by mini-css-extract-plugin
export default {"footer-box":"HeaderList_footer-box__Wd4iq","header-table":"HeaderList_header-table__Ypw02"};